import * as React from 'react';
import { CurrencyInput } from '../../../components/form-elements/CurrencyInput';
import { CurrencyChangeCallbackWithID } from '../../../models/utilities/function-types';
import { formatCurrency } from '../../../utils/currency-formatter';
import { DeliveryStatus } from '../../models/enums/delivery-status';
import { OrderSummary } from '../../models/shared/order-summary';
import { DeliveryShipmentAction } from '../../models/shipments/shipment-action';

interface IProps {
    delivery    : DeliveryShipmentAction;
    onCODChange : CurrencyChangeCallbackWithID;
}

export const ShipmentActionCODRow = (props: IProps) => {

    let codAmount : any;

    const handleCODChange = (e : React.FormEvent<HTMLInputElement>, newValue : number) => {
        props.onCODChange(props.delivery.id, newValue);
    };

    /**
     * Get the panel title based on the data we have available
     */
    const getPanelTitle = () => {
        return props.delivery.address && props.delivery.address.addressLine1.length > 0
            ? <React.Fragment>
                <span>{props.delivery.address.addressLine1}</span><br/>
                <span>
                    {
                        `${props.delivery.address.city}, 
                    ${props.delivery.address.stateProvince} 
                    ${props.delivery.address.postalCode}`
                    }
                </span>
            </React.Fragment>
            : <React.Fragment>
                <span>PICKUPS</span>
                <span>ONLY</span>
            </React.Fragment>;
    };

    const sumOrders = () => {
        const sum = props.delivery.orders.reduce((acc : number, curr : OrderSummary) => {
            return acc + curr.total;
        }, 0);

        return formatCurrency(sum);
    };

    return  <tr>
                <td>
                    { getPanelTitle() }
                </td>
                <td>
                    { props.delivery.dealerId }
                </td>
                <td>
                    { sumOrders() }
                </td>
                <td className="row-cell">
                    <CurrencyInput
                        id={`${ props.delivery.id}-cod-row`}
                        value={ props.delivery.codAmount}                
                        label=""
                        currencyType={"USD"}
                        showSymbol={true}
                        ref={(instance) => { codAmount = instance; }}
                        disable={ props.delivery.status !== DeliveryStatus.Open }
                        onChange={ handleCODChange }
                    />
                </td>
            </tr>;
};
